export const GET_PLANS_REQUEST = '@plans/GET_PLANS_REQUEST';
export const GET_PLANS_SUCCESS = '@plans/GET_PLANS_SUCCESS';
export const GET_PLANS_FAILURE = '@plans/GET_PLANS_FAILURE';

export const GET_PLAN_BY_ID_REQUEST = '@plans/GET_PLAN_BY_ID_REQUEST';
export const GET_PLAN_BY_ID_SUCCESS = '@plans/GET_PLAN_BY_ID_SUCCESS';
export const GET_PLAN_BY_ID_FAILURE = '@plans/GET_PLAN_BY_ID_FAILURE';

export const DELETE_PLAN_REQUEST = '@plans/DELETE_PLAN_REQUEST';
export const DELETE_PLAN_SUCCESS = '@plans/DELETE_PLAN_SUCCESS';
export const DELETE_PLAN_FAILURE = '@plans/DELETE_PLAN_FAILURE';

export const CLEAN_PLAN_ITEM = '@plans/CLEAN_PLAN_ITEM';

export const POST_PLAN_REQUEST = '@plans/POST_PLAN_REQUEST';
export const PUT_PLAN_REQUEST = '@plans/PUT_PLAN_REQUEST';
